import styled from 'styled-components';

import { Box } from '@mui/material';

import { colors } from '../../theme';

const ContentContainer = (props: any) => {
    const { padding, height } = props;
    return (
        <Box 
        sx={{
            ...props.sx,
            background: colors.white,
            borderRadius: '5px',
            boxShadow: ' 0px 2px 10px rgba(0, 0, 0, 0.05)',
            p: padding ? padding : '15px 10px',
            mt: '10px',
            height: `calc(100vh - ${height ? height : '145px'})`,
            overflowY:'scroll'
        }}>
            {props.children}
        </Box>
    );
};

export default ContentContainer;
